//Paquetes NPM de GYF.
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { RESET_ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE } from '../../VistaCliente/actions/VistaClienteActions';
import distribucionLimitesReducer from '../../../Store/Reducers/DistribucionLimites';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const GET_ADMINISTRATOR_DATA_RESULT = 'GET_ADMINISTRATOR_DATA_RESULT';
export const GET_ADMINISTRATOR_DATA = 'GET_ADMINISTRATOR_DATA';
export const GET_ADMINISTRATOR_DATA_ROUTTING = 'GET_ADMINISTRATOR_DATA_ROUTTING';
export const ROUTE_TO_ADMINISTRADORA = 'ROUTE_TO_ADMINISTRADORA';
export const ROUTE_TO_TARJETAS = 'ROUTE_TO_TARJETAS';
export const ROUTE_TO_TIPO_EMPRESA = 'ROUTE_TO_TIPO_EMPRESA';
export const ROUTE_TO_EMPRESA = 'ROUTE_TO_EMPRESA';
export const ROUTE_TO_CUENTA = 'ROUTE_TO_CUENTA';
export const ROUTE_TO_PRODUCTO = 'ROUTE_TO_PRODUCTO';
export const ROUTE_TO_CONFIRMACION = 'ROUTE_TO_CONFIRMACION';
export const ROUTE_TO_CANCEL_ADMINISTRADORA = 'ROUTE_TO_CANCEL_ADMINISTRADORA';
export const SELECT_RADIOBUTTON_NUEVAADMINISTRADORA = 'SELECT_RADIOBUTTON_NUEVAADMINISTRADORA';
export const SHOW_ERROR = 'SHOW_ERROR';
export const ROUTE_TO_VISTACLIENTE_FROM_ADM = 'ROUTE_TO_VISTACLIENTE_FROM_ADM';
export const CANCEL = 'CANCEL';
export const FUNCTION_CODE_CREATE = 'Alta';
export const FUNCTION_CODE_QUERY = 'Consulta';
export const ACTUALIZAR_ESTADO_GLOBAL_ADMINISTRADORA = 'ACTUALIZAR_ESTADO_GLOBAL_ADMINISTRADORA';
export const RESET_STATE_NUEVA_SOLICITUD_ADMINISTRADORA = 'RESET_STATE_NUEVA_SOLICITUD_ADMINISTRADORA';

let _dispatch, _routingState, _datosSolicitud = null;
let userFeatures = [];

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        const state = getState();

        _datosSolicitud = state.tarjetas;

        dispatch({ type: RESET_ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE });
        dispatch({ type: GET_ADMINISTRATOR_DATA, state });

        const reducers = [];
        reducers.push(distribucionLimitesReducer);
        dispatch({ type: 'STORE_INJECT', reducers: reducers });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => resultadoCargaDeDatosInicial(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_STATE_NUEVA_SOLICITUD_ADMINISTRADORA });
    }
}

/**
 * Routea a la pagina "Tipo de empresas".
 */
export function routeTipoEmpresa(administradora) {
    LogHelper.In(routeTipoEmpresa.name, administradora);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: ACTUALIZAR_ESTADO_GLOBAL_ADMINISTRADORA, administradora: administradora });
        dispatch({ type: ROUTE_TO_TIPO_EMPRESA });
    }
}

/**
 * Cancela el proceso de "Nueva Solicitud".
 */
export function cancel() {
    LogHelper.In(cancel.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: CANCEL
        });
    }
}

/**
 * Selecciona una administradora.
 * @param {any} id
 * @param {any} descripcion
 * @param {any} codigo
 */
export function selectRadioButton(id, descripcion, codigo) {
    LogHelper.In(selectRadioButton.name, id, descripcion, codigo);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        let state = getState().nuevaSolicitudAdministradora;
        let administradora = state.administradora && state.administradora.filter(adm=>adm.Id == id)[0]
        
        dispatch({
            type: SELECT_RADIOBUTTON_NUEVAADMINISTRADORA,
            valueId: id,
            valueDescripcion: descripcion,
            codigo: codigo
        });
        dispatch({ type: ACTUALIZAR_ESTADO_GLOBAL_ADMINISTRADORA, administradora: administradora });
    }
}

/**
 * Muestra mensaje de error.
 */
export function showError() {
    LogHelper.In(showError.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: SHOW_ERROR
        });
    }
}

/**
 * Routea a la pagina que debe ir cuando se cancela el proceso de "Nueva Solicitud".
 */
export function routeToCancel() {
    LogHelper.In(routeToCancel.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: ROUTE_TO_CANCEL_ADMINISTRADORA
        });
    }
}

export function actualizarEstadoGlobal() {
    LogHelper.In(actualizarEstadoGlobal.name);

    return (dispatch, getState) => {
        let estado = getState();

        _dispatch = dispatch;
        dispatch({
            type: ACTUALIZAR_ESTADO_GLOBAL,
            administradora: estado.administradora
        });
    }
}

/**
 *
 */
export function routeToVistaCliente() {
    LogHelper.In(routeToVistaCliente.name);

    return (dispatch, getState) => {
        dispatch({ type: ROUTE_TO_VISTACLIENTE_FROM_ADM });
    }
}



/*-------------------------------------FUNCIONES AUXILIARES -------------------------------------*/

/**
 * Resultados de la busqueda de los datos para inicializar la pantala nueva solicitud ADMINISTRADORAS.
 * @param {any} data
 */
export function resultadoCargaDeDatosInicial(data, ...params) {
    LogHelper.In(resultadoCargaDeDatosInicial.name, data, ...params);

    _datosSolicitud = (_datosSolicitud || params[0]);
    _dispatch = (_dispatch || params[1]);

    userFeatures = JSON.parse(JSON.stringify(data));

    let adminEmpCueTarFunctions = JSON.parse(JSON.stringify(data.ADMINEMPCUETAR));
    let adminEmpCueTarFunctionsAllowed = [];
    adminEmpCueTarFunctions.forEach(p => { adminEmpCueTarFunctionsAllowed[p.Codigo_Funcion] = true; });

    let solicitudFunctions = JSON.parse(JSON.stringify(data.SOLICITUD));
    let solicitudFunctionsAllowed = [];
    solicitudFunctions.forEach(p => { solicitudFunctionsAllowed[p.Codigo_Funcion] = true; });

    let permisos = {
        components: {
            Pantalla: { Active: false, Locked: false },
            RadioButtons: { Active: false, Locked: false },
            BotonesAnteriorSiguiente: { Active: false, Locked: false },
            BotonGuardarBorrador: { Active: false, Locked: false }
        },
        funcionesDelUsuario: {}
    };

    solicitudFunctions.forEach(p => { permisos.funcionesDelUsuario[p.Codigo_Funcion] = true; });

   /* if (_datosSolicitud.esModificacion == true) {
        switch (_datosSolicitud.estadoSolicitud.toLowerCase()) {
            case "borrador": {
                if (permisos.funcionesDelUsuario.Consulta == true) {
                    permisos.components.Pantalla.Active = true
                    permisos.components.BotonesAnteriorSiguiente.Active = true;

                    if (permisos.funcionesDelUsuario.Modificacion == true) {
                        permisos.components.RadioButtons.Active = true;
                        permisos.components.BotonGuardarBorrador.Active = true;
                    }
                } else {
                    
                    permisos.components.Pantalla = { Active: false }
                };
                break;
            }
            case "cuenta / tarjeta parcialmente aceptada por adm":
            case "cuenta / tarjeta rechazada por adm":
            case "empresa rechazada por adm":
            case "denegada banco":
            case "completada":
            case "confirmada": {
                if (permisos.funcionesDelUsuario.Consulta == true) {
                    permisos.components.Pantalla.Active = true
                    permisos.components.BotonesAnteriorSiguiente.Active = true;

                    let completadaResult = _datosSolicitud.estadoSolicitud.toLowerCase() == "completada"
                        && (permisos.funcionesDelUsuario.Modificacion == true);

                    let confirmadaResult = _datosSolicitud.estadoSolicitud.toLowerCase() == "confirmada"
                        && (permisos.funcionesDelUsuario.Modificacion == true);

                    let denegadaResult = _datosSolicitud.estadoSolicitud.toLowerCase() == "denegada banco"
                        && (permisos.funcionesDelUsuario.Modificacion == true);

                    let ctpResult = _datosSolicitud.estadoSolicitud.toLowerCase() == "cuenta / tarjeta parcialmente aceptada por adm"
                        && (permisos.funcionesDelUsuario.Modificacion == true);

                    let ctrResult = _datosSolicitud.estadoSolicitud.toLowerCase() == "cuenta / tarjeta rechazada por adm"
                        && (permisos.funcionesDelUsuario.Modificacion == true);

                    let erResult = _datosSolicitud.estadoSolicitud.toLowerCase() == "empresa rechazada por adm"
                        && (permisos.funcionesDelUsuario.Modificacion == true);

                    if (completadaResult || confirmadaResult || denegadaResult || ctpResult || ctrResult || erResult) {
                        permisos.components.RadioButtons.Active = true;
                        permisos.components.BotonGuardarBorrador.Active = true;
                    }
                } else {
                    
                    permisos.components.Pantalla = { Active: false }
                };
                break;
            }
            case "enviada": {
                if (permisos.funcionesDelUsuario.Consulta == true) {
                    permisos.components.Pantalla.Active = true
                    permisos.components.BotonesAnteriorSiguiente.Active = true;

                    permisos.components.RadioButtons = { Active: true, Locked: true };
                    permisos.components.BotonGuardarBorrador = { Active: true, Locked: true };
                } else {
                    
                    permisos.components.Pantalla = { Active: false }
                };
                break;
            }
            default: {
                break;
            }
        }
    } else {*/
        if (permisos.funcionesDelUsuario.Alta == true) {
            permisos.components.Pantalla.Active = true;
            permisos.components.RadioButtons.Active = true;
            permisos.components.BotonGuardarBorrador.Active = true;

            if (permisos.funcionesDelUsuario.Consulta == true) {
                permisos.components.BotonesAnteriorSiguiente.Active = true;
            }
        } else {
            /*Si no tiene permisos sobre el alta, no es necesario que valide las demas funciones, ya que no
            será capaz de acceder a la pantalla*/
            permisos.components.Pantalla.Active = false;
        }
   // }

    if (permisos.components.Pantalla.Active == true) {
        LogHelper.Out(resultadoCargaDeDatosInicial.name, null, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.Execute(_loadNewRequestAdministratorInitialStateData, null, permisos, "PARAMETRIA");
    } else {
        _dispatch({ type: GET_ADMINISTRATOR_DATA_RESULT, permisos: permisos });
    }
}

/**
 * 
 * @param {any} data
 */
function _loadNewRequestAdministratorInitialStateData(data) {
    LogHelper.In(_loadNewRequestAdministratorInitialStateData.name, data);

    _dispatch({
        type: GET_ADMINISTRATOR_DATA_RESULT,
        permisos: data.CALLER_ID,
        showError: false,
        administrator: JSON.parse(data.GET_ADMINISTRADORA).Recordset0.Rows,
    });
}

/**
 * Limpia.
 */
function clean() {

}






// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/NuevaSolicitudAdministradora/actions/NuevaSolicitudAdministradoraActions.js